

















































































































































































import { checklistPostReq } from "@/services/checklist.service";


import draggable from "vuedraggable";

// machinegroups-overview
export default {
  data() {
    return {
      na1: false,
      initLoaded: false,
      create_dialog: false,
      create_progress: false,
      create_error: false,
      delete_dialog: false,
      delete_item: {},
      delete_progress: false,
      export_dialog: false,
      showTransferInspect: false,
      cl_item: null,

      machine_item: {}, 

      //----

     
      
      
      create_name: "",
      update_uid: null,
      delete_uid: null,
      search: "",
      headers: [
        { text: "ID", value: "uid" },
        { text: "machineManufacturer", value: "machineManufacturer" },
        {
          text: "machineType",
          value: "machineType",
        },
        { text: "nominalPower", value: "nominalPower" },
        { text: "hubHeight", value: "hubHeight" },
        { text: "rotorDiameter", value: "rotorDiameter" },
      ],
    };
  },
  components: {
  },

  mounted() {
    this.$store.state.headerTitle = this.$t("NAVI.MACHINES"); 

    //var db = new PouchDB('dbname');

    checklistPostReq("machinelist-overview", {})
      .then((resp) => {
        if (resp.status == "success") {
          console.log(resp)
          this.$store.state.machines = resp.data.machines;
          this.initLoaded = true;
        }
      })
      .catch((e) => {
        this.$store.dispatch("api_error", e);
      });
  },
  computed: {
    machines: function () {
      return this.$store.state.machines;
    },
  },
  methods: {
   
    openMachine(ev, item) {
      this.machine_item = JSON.parse(JSON.stringify(item)) 
      ev.preventDefault()
      this.create_dialog = true;
    },
    deleteGroup(item) {
      this.delete_uid = item.uid;
      this.delete_dialog = true;
      this.delete_item = item;
    },

    deleteGroupAction() {
      this.delete_progress = true;
      checklistPostReq("machinegroups-remove", { uid: this.delete_uid })
        .then((resp) => {
          if (resp.status == "success") {
            this.$store.state.machines_group_list = resp.data.list;
            this.delete_dialog = false;
            this.delete_progress = false;
          }
        })
        .catch((e) => {
          this.$store.dispatch("api_error", e);
        });
    },
    saveMachineItem() {
      this.create_error = false

      if (this.machine_item.machineManufacturer && this.machine_item.machineType && this.machine_item.machineManufacturer.length > 1 && this.machine_item.machineType.length > 1) {
        this.create_progress = true;

        checklistPostReq("machine-update", {
          machine_item: this.machine_item
        })
          .then((resp) => {
            console.log("resp", resp)
            if (resp.status == "success") {
              this.create_progress = false;
              this.$store.state.machines = resp.data.machines;
              this.create_dialog = false;
            }
          })
          .catch((e) => {
            this.$store.dispatch("api_error", e);
          });
     
      }
      else {
        this.create_error = true
      }
     
    },
  },
};
